var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0219 2L5.49669 6.64605L2 10.4235H2.78703L5.84845 7.11621L8.3219 10.4235H11L7.32962 5.51618L10.5844 2H9.79733L6.97802 5.04586L4.7 2H2.0219ZM3.17926 2.57966H4.40957L9.84249 9.84385H8.61218L3.17926 2.57966Z",
    fill: "#EEE0F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterS);
export default __webpack_public_path__ + "static/media/twitter-s.8edf8b35fe5d7627bbdcca3d95e19943.svg";
export { ForwardRef as ReactComponent };